export default "__VITE_ASSET__ivGSrCqd__"